module.exports = __webpack_public_path__ + "static/media/avatar.52461b2a.png";